import React, { useState, useRef } from "react";
import { withRouter } from "react-router";
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import ReactWheel from './FortuneWheel'



function WheelOfFortune(props)  {

    const classes = useStyles();
    const wheelRef = useRef(null);
    const wheelRef2 = useRef(null);
    const [checkbox1, setCheckbox1] = useState(false)
    const [checkbox2, setCheckbox2] = useState(false)
    const [isSpinning, setIsSpinning] = useState(false)
    const [hasSpinned, setHasSpinned] = useState(false)
    const [counterSpins, setCounterSpins] = useState(0)
    const [score, setScore] = useState(0)
    const [resWheel1, setResWheel1] = useState(0)
    const [resWheel2, setResWheel2] = useState(0)
    const [hasAnsweredYet, setHasAnsweredYet] = useState(false)
    const [hasCheated, setHasCheated] = useState(0)

    const segments = [
		{
			name: '+50',
			color: 'green'
    },
    {
			name: '+50',
			color: 'green'
		},
		{
			name: '+25',
			color: 'green'
		},
		{
			name: '+25',
			color: 'green'
		},
    ];
    const segments2 = [
		{
			name: '+200',
			color: 'green'
    },
    {
			name: '0',
			color: 'blue'
		},
		{
			name: '+10',
			color: 'green'
		},
		{
			name: '-50',
			color: 'red'
		},
	];

    const handleClick=(event)=>{
        event.preventDefault()
        var cheat = 0
        // var finalScore = 0
        if(counterSpins > 6){
            cheat = 2
        } else if( counterSpins >= 5){
            cheat = 1
        }
        // if(score > 400){
        //     finalScore = 40
        // }else{
        //     finalScore = score/10
        // }
        console.log(score)
        props.sendDataToParent( score, score, cheat + hasCheated)
    }

	const onSpinClick = () => {
    // On uncheck les cases pour meler le user
    if (checkbox1) {
      setCheckbox1(false)
    }
    if (checkbox2) {
      setCheckbox2(false)
    }

    // Re-initialise les etats
    setHasAnsweredYet(false)
    setIsSpinning(true)
    setHasSpinned(false)

    // Fait tourner
    wheelRef.current.spinWheel();
    wheelRef2.current.spinWheel();
    setCounterSpins(counterSpins+1)
	};
	const onSpinComplete1 = ( result ) => {
    // Update les etats
    setIsSpinning(false)
    setHasSpinned(true)
    setResWheel1(result.name)
    if (checkbox1) {
      console.log("Le user a eu le temps de check avant la fin")
      if (result.name==="+50") {
        setScore(score + 50)
      } else if (result.name === "+25") {
        setScore(score + 25)  
      }
      setHasAnsweredYet(true)
    }
  };
  
  const onSpinComplete2 = ( result ) => {
    setIsSpinning(false)
    setHasSpinned(true)
    setResWheel2(result.name)
    // The case with '0', we ignore it
    if (checkbox2) {
      setHasAnsweredYet(true)
      if (result.name==="+200") {
        setScore(score + 200)
      } else if (result.name==="-50") {
        setScore(score - 50)
      } else if (result.name === "+10") {
        setScore(score + 10)
      }
      setHasAnsweredYet(true)
    }
	};

  const changeCheckbox1=()=>{
    // Applique le checking
    setCheckbox1(!checkbox1)

    // Si on uncheck, on ne fait rien et retourne
    if (checkbox1) {
      return
    }

    // Enleve l'autre s'il est check
    if (checkbox2) {
      setCheckbox2(!checkbox2)
    }

    // Si le spinner a fini
    // que le spinner ne tourne pas
    // et que c'est la premiere fois qu'il selectionne un checkbox
    // On applique le score, mais cas de triche
    if (hasSpinned && !isSpinning && !hasAnsweredYet) {
      if (resWheel1 === "+50") {
        setScore(score + 50)
      } else if (resWheel1 === "+25") {
        setScore(score + 25)  
      }
      setHasCheated(2)
      console.log('Check 1 : triche + points')
    }
    setHasAnsweredYet(true)
  }
  const changeCheckbox2=()=>{
    // Applique le checking
    setCheckbox2(!checkbox2)

    // Si on uncheck, on ne fait rien et retourne
    if (checkbox2) {
      return
    }

    // Enleve l'autre s'il est check
    if (checkbox1) {
      setCheckbox1(!checkbox1)
    }

    // Si le spinner a fini
    // que le spinner ne tourne pas
    // et que c'est la premiere fois qu'il selectionne un checkbox
    // On applique le score, mais cas de triche
    if (hasSpinned && !isSpinning && !hasAnsweredYet) {
      if (resWheel2 === "+200") {
        setScore(score + 200)
      } else if (resWheel2 === "-50") {
        setScore(score - 50)
      } else if (resWheel2 === "+10") {
        setScore(score + 10)
      }
      setHasCheated(2)
    }  
    setHasAnsweredYet(true)
  }

return (

    <div className={classes.root}>
            <div className={classes.hotContainer}>
                <div className={classes.description}>
                    <p style={{marginBottom: '0px', marginTop: '0px'}}> Voici face à vous 2 roulettes de casino, l'une risquée et l'autre plus raisonnable. Vous avez 4 essais pour augmenter au maximum votre résultat.
                    </p>
                    <ol>
                        <li>Faites tourner les roulettes.</li>
                        <li>Assurez-vous d'avoir selectionné la roulette avant qu'elle ne cesse de tourner</li>
                        <li>Répéter 4 fois</li>
                        <li>Vous verrez le nombre de points que avez accumulé dans la case <i>Votre score actuel</i> prévu à cet effet</li>
                    </ol>
                </div>
                <div className={classes.horizontalContainer}>
                    <div className={classes.spinButtonVertical}>
                        <p style={{marginTop: '0px'}}>Nombre d'essais : <b>{counterSpins}</b></p>
                        <p style={{marginTop: '0px'}}>Votre score actuel : <b>{score}</b></p>
                        <Button variant="outlined" color="secondary" onClick={onSpinClick}>
                            Rouler les roulettes   
                        </Button>
                    </div>
                    {/* <div className={classes.wheelsContainer}> */}
                        <div className={classes.wheels}>
                            <input
                                type="checkbox"
                                checked={checkbox1}
                                onChange={changeCheckbox1}
                                // style={{marginRight:'40px'}}
                            />
                            <div 
                            // style={{marginRight:'40px'}}
                            >
                                <ReactWheel
                                    segments={segments}
                                    onComplete={onSpinComplete1}
                                    ref={wheelRef}                                    
                                />
                            </div>                            
                        </div>
                        <div className={classes.wheels}>
                            <input
                                type="checkbox"
                                checked={checkbox2}
                                onChange={changeCheckbox2} 
                            />
                            <div>
                                <ReactWheel
                                    segments={segments2}
                                    onComplete={onSpinComplete2}
                                    ref={wheelRef2}
                                />
                            </div>
                        </div>
                    {/* </div>    */}
                </div>
            </div>
        <div className={classes.submitButton}>
            <Button variant="outlined" color="primary" onClick={handleClick}>Prochaine tâche</Button>
        </div>
    </div>

)}


const useStyles = makeStyles({

    wheels:{
        display:'flex',
        flexDirection:'column',
        alignItems:'center',
        justifyContent:'center'
    },
    hotContainer:{
        justifyContent:'center',
        alignItems:'center',
        padding : 10,
    },
    // horizontalContainer:{
    //     flexDirection:'row',
    //     display:'flex',
    //     flex:1,
    // },
    horizontalContainer:{
        display: 'grid',
        gridTemplateColumns: '4fr 1fr 1fr',
        gap: '10px',
    },
    description: {
        display: 'flex',
        textAlign: 'left',
        'flex-direction': 'column',
        alignItems: "left",
        width: '80%',
        marginLeft: '10%',
    },
    centered:{
        display:'flex',
        flex:1,
        flexDirection:'column'
    },
    root:{
        display:'flex',
        flex:1,
        flexDirection:'column'
    },
    submitButton:{
        display:'flex',
        alignSelf:'center',
        justifyContent:'center',
    },
    wheelsContainer:{
        display:'flex',
        flexDirection:"row",
        flex:2,
        justifyContent:'center',
        alignItems:'center',
    },
    spinButtonVertical:{
        flexDirection:'column',
        display:'flex',
        flex:2,
        justifyContent:'center',
        alignItems:'center',
        backgroundColor : 'rgb(244,	246,248)',
        padding:15,
        border : 'solid',
        borderColor : '#00000050',
        borderRadius: 25
    }
})

 
export default withRouter(WheelOfFortune);